const settings = {
  baseGrid: {
    fontSize: 16,
    lineGap: 12,
  },
  voiceGrid: {
    fontSize: 16,
    lineGap: 20,
  },
  color: {
    main: "#1A3080",
    darken: "#010E3D",
    accent: "#E50012",
    pale: "#EEF1F6",
    paleDarker: "#D0D7E4",
    darkGray: "#D3D7DC",
    gray: "#b2b4b8"
  },
  font: {
    jp: `"Noto Sans JP", sans-serif`,
    en: `"Montserrat", serif`
  },
  radius: {
    medium: 35,
    small: 14
  },
  contentGutter: {
    md: 9,
  },
  contentWidth: {
    xxl: (16*5+16)*12-16,
    xl: (16*5+16)*10-16,
    lg: (16*5+16)*8-16,
    md: (16*5+16)*6-16,
    sm: (16*4+16)*6-16,
    xs: (16*4+16)*4-16  
  },
  breakpoint: {
    xxl: 16*92,
    xl: 16*64,
    lg: 16*52,
    md: 16*40,
    sm: 16*36,
  }
}

export default settings;